var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm.item.meta && _vm.item.meta.hidden
    ? _c("div")
    : _vm.item.meta && _vm.item.meta.auth
    ? _c(
        "div",
        [
          _vm.item.children &&
          _vm.item.children.length &&
          _vm.hasAnyRole(_vm.item.meta.auth)
            ? [
                _c(
                  "q-collapsible",
                  {
                    staticStyle: { "font-size": "13px" },
                    attrs: {
                      icon:
                        _vm.item.meta && _vm.item.meta.icon
                          ? _vm.item.meta.icon
                          : "keyboard_arrow_right",
                      label:
                        _vm.item.meta && _vm.item.meta.title
                          ? _vm.item.meta.title
                          : _vm.item.meta.resource,
                      separator: "",
                      opened: _vm.opened,
                      sublabel: _vm.item.meta.sublabel
                    }
                  },
                  [
                    _vm._l(_vm.item.children, function(child) {
                      return [
                        child.children &&
                        child.children.length &&
                        child.meta &&
                        _vm.hasAnyRole(child.meta.auth)
                          ? _c("sidebar-nav", {
                              key: child.path,
                              attrs: { item: child }
                            })
                          : child.meta && child.meta.hidden
                          ? void 0
                          : child.meta && _vm.hasAnyRole(child.meta.auth)
                          ? _c(
                              "q-item",
                              {
                                key: child.path,
                                staticStyle: { "font-size": "13px" },
                                attrs: {
                                  separator: "",
                                  link: "",
                                  to: { path: "/" + child.path }
                                }
                              },
                              [
                                _c(
                                  "q-item-main",
                                  [
                                    _c("q-icon", {
                                      staticClass: "q-mr-sm",
                                      staticStyle: { "margin-right": "20px" },
                                      attrs: {
                                        name:
                                          child.meta && child.meta.icon
                                            ? child.meta.icon
                                            : "keyboard_arrow_right",
                                        size: "16px",
                                        color: ""
                                      }
                                    }),
                                    _c("span", [
                                      _vm._v(
                                        _vm._s(
                                          child.meta && child.meta.title
                                            ? child.meta.title
                                            : child.path
                                        )
                                      )
                                    ])
                                  ],
                                  1
                                )
                              ],
                              1
                            )
                          : _vm._e()
                      ]
                    })
                  ],
                  2
                )
              ]
            : [
                _vm.item.meta && _vm.item.meta.hidden
                  ? void 0
                  : _vm.hasAnyRole(_vm.item.meta.auth)
                  ? _c(
                      "div",
                      [
                        _c(
                          "q-item",
                          {
                            key: _vm.item.path,
                            staticStyle: { "font-size": "13px" },
                            attrs: {
                              separator: "",
                              link: "",
                              to: { path: _vm.item.path }
                            }
                          },
                          [
                            _c(
                              "q-item-main",
                              [
                                _c("q-icon", {
                                  staticClass: "q-mr-sm",
                                  staticStyle: { "margin-right": "20px" },
                                  attrs: {
                                    name:
                                      _vm.item.meta && _vm.item.meta.icon
                                        ? _vm.item.meta.icon
                                        : "keyboard_arrow_right",
                                    size: "16px",
                                    color: ""
                                  }
                                }),
                                _c("span", [
                                  _vm._v(
                                    _vm._s(
                                      _vm.item.meta && _vm.item.meta.title
                                        ? _vm.item.meta.title
                                        : _vm.item.path
                                    )
                                  )
                                ])
                              ],
                              1
                            )
                          ],
                          1
                        )
                      ],
                      1
                    )
                  : _vm._e()
              ]
        ],
        2
      )
    : _vm._e()
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }